import { useContext, useEffect, useState } from "react";
import UserContext from "../../contexts/UserContext";
import { Link, useNavigate } from "react-router-dom";
import { config } from "../../constants/config";
import { textes } from "../../constants/textes";
import { Spinner } from "react-bootstrap";
import { BuildingFill, CreditCard, People, PeopleFill, PersonCheckFill } from "react-bootstrap-icons";

// // import { formatDate } from '@fullcalendar/core'
// import FullCalendar from "@fullcalendar/react";
// import dayGridPlugin from "@fullcalendar/daygrid";
// import timeGridPlugin from "@fullcalendar/timegrid";
// import interactionPlugin from "@fullcalendar/interaction";
import SiteDash from "../sites/sitedash";
import HotspotDash from "../hotspots/hotsoptdash";
import TransactionDash from "../transactions/transactiondash";
import Allretrait from "../retrais/retraitall";

export default function HomeDashbord() {
  // states
  const { user, logoutUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [loading3, setLoading3] = useState(true);
  const [loading4, setLoading4] = useState(true);
  const [error, setError] = useState(false);
  // const [events, setEvents] = useState([]);
  const [page, setPage] = useState(0);

  const [nbtjour, setnbtjour] = useState(0);
  const [nbtmois, setnbtmois] = useState(0);
  const [nbtannee, setnbtannee] = useState(0);
  const [nbttotal, setnbttotal] = useState(0);

  const [monttjour, setmonttjour] = useState(0);
  const [monttmois, setmonttmois] = useState(0);
  const [monttannee, setmonttannee] = useState(0);
  const [montttotal, setmontttotal] = useState(0);

  const [nbsite, setnbsite] = useState(0);
  const [nbuser, setnbuser] = useState(0);
  const [nbuserconnect, setnbuserconnect] = useState(0);
  const [nbrevendeur, setnbrevendeur] = useState(0);

  const [transactions, settransactions] = useState([]);
  const [sites, setsites] = useState([]);
  const [hotsopts, sethotsopts] = useState([]);
  const [retraits, setretraits] = useState([]);

  const currentdate = new Date().toLocaleDateString('en-GB', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).split('/').reverse().join('-');

  console.log("current date:", currentdate);
  console.log("current date day:", currentdate.slice(0, 7) + "-01");
  console.log("current month:", currentdate.slice(5, 7));
  console.log("current year:", currentdate.slice(0, 4));
  console.log("current ngom:", currentdate.slice(0, 7) + "-" + getlastnbday(new Date()));

  function getlastnbday(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
  }

  // function getcurrentyear(date) {
  //   return new Date(date.getFullYear())
  // }

  // const getElementsList = async (p) => {
  //   setLoading(true);

  //   var myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  //   myHeaders.append("Authorization", user.token);
  //   myHeaders.append("cpte", user.code);
  //   myHeaders.append("prof", user.profil);
  //   myHeaders.append("conn", user.token);

  //   var requestOptions = {
  //     method: "GET",
  //     headers: myHeaders,
  //     // body: urlencoded,
  //     redirect: "follow",
  //   };

  //   let structarraydata = [];

  //   // console.log("data send", urlencoded)


  // };

  const getCounts = async (p) => {

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("token", config.app.PUBLICKEY);
    myHeaders.append("apikey", user.token);
    myHeaders.append("cpte", user.code);
    myHeaders.append("prof", user.profil);
    myHeaders.append("conn", user.espace);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      // body: urlencoded,
      redirect: 'follow'
    };

    // console.log("data send", urlencoded)

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&deb=${currentdate}&etat=4`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setnbtjour(data?.body?.length);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&deb=${currentdate.slice(0, 7) + "-01"}&fin=${currentdate.slice(0, 7) + "-" + getlastnbday(new Date())}&etat=4`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setnbtmois(data?.body?.length);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&deb=${currentdate.slice(0, 4) + "-01-01"}&fin=${currentdate.slice(0, 4) + "-12-" + getlastnbday(new Date())}&etat=4`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setnbtannee(data?.body?.length);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&etat=4`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setnbttotal(data?.body?.length);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    // montants
    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&etat=4&defaut=false&deb=${currentdate}`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setmonttjour(data?.body?.data[0]?.sum !== null ? data?.body?.data[0]?.sum : 0);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&etat=4&defaut=false&deb=${currentdate.slice(0, 7) + "-01"}&fin=${currentdate.slice(0, 7) + "-" + getlastnbday(new Date())}`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setmonttmois(data?.body?.data[0]?.sum !== null ? data?.body?.data[0]?.sum : 0);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&etat=4&defaut=false&deb=${currentdate.slice(0, 4) + "-01-01"}&fin=${currentdate.slice(0, 4) + "-12-" + getlastnbday(new Date())}}`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setmonttannee(data?.body?.data[0]?.sum !== null ? data?.body?.data[0]?.sum : 0);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=${100000000}&page=${p + 1}&etat=4&defaut=false`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setmontttotal(data?.body?.data[0]?.sum !== null ? data?.body?.data[0]?.sum : 0);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    // stats sites
    await fetch(`${config.secure.BASE_URL}/${config.secure.PROJECT}/users?type=revendeur&limit=${100000000}&page=${p + 1}`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setnbrevendeur(data?.body?.length);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?limit=${100000000}&page=${p + 1}`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setnbsite(data?.body?.length);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?limit=${100000000}&page=${p + 1}&crit=allconnectedusers`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setnbuserconnect(data?.body?.length);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?limit=${100000000}&page=${p + 1}&crit=allusers`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            // let clientarray = [];

            // clientarray = data?.body?.data;

            // setElementsList(clientarray);
            // setNbpage(data?.body?.pages);
            setnbuser(data?.body?.length);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              console.log("get count error 1 server");
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        console.log("get count error 1 statut");
      }

    }).catch((err) => {
      console.log("get count error 1 catch");
    });
  }

  const getRetraits = async (p) => {
    setLoading(true);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("token", config.app.PUBLICKEY);
    myHeaders.append("apikey", user.token);
    myHeaders.append("cpte", user.code);
    myHeaders.append("prof", user.profil);
    myHeaders.append("conn", user.espace);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      // body: urlencoded,
      redirect: 'follow'
    };

    // console.log("data send", urlencoded)


    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/withdrawalrequests?limit=${config.app.limit}&page=${p + 1}&etat=1,2`, requestOptions).then((response) => {

      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data);
          if (data?.head) {
            let clientarray = [];

            clientarray = data?.body?.data;
            setretraits(clientarray);
            setLoading(false);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              setError(true);
              setLoading(false);
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        setError(true);
        setLoading(false);
      }

    }).catch((err) => {
      // console.log("error", err);
      setError(true);
      setLoading(false);
    });

  }

  const getSites = async (p) => {
    setLoading2(true);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("token", config.app.PUBLICKEY);
    myHeaders.append("apikey", user.token);
    myHeaders.append("cpte", user.code);
    myHeaders.append("prof", user.profil);
    myHeaders.append("conn", user.espace);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      // body: urlencoded,
      redirect: 'follow'
    };

    // console.log("data send", urlencoded)

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/sites?limit=${config.app.limit}&page=${p + 1}&etat=1`, requestOptions).then((response) => {

      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data);
          if (data?.head) {
            let clientarray = [];

            clientarray = data?.body?.data;
            setsites(clientarray);
            setLoading2(false);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              setError(true);
              setLoading2(false);
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        setError(true);
        setLoading2(false);
      }

    }).catch((err) => {
      // console.log("error", err);
      setError(true);
      setLoading2(false);
    });
  }

  const getHotspots = async (p) => {
    setLoading3(true);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("token", config.app.PUBLICKEY);
    myHeaders.append("apikey", user.token);
    myHeaders.append("cpte", user.code);
    myHeaders.append("prof", user.profil);
    myHeaders.append("conn", user.espace);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      // body: urlencoded,
      redirect: 'follow'
    };

    // console.log("data send", urlencoded)

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/hotspots?limit=${config.app.limit}&page=${p + 1}&etat=1`, requestOptions).then((response) => {

      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data);
          if (data?.head) {
            let clientarray = [];

            clientarray = data?.body?.data;
            sethotsopts(clientarray);
            setLoading3(false);
          } else {
            if (data?.body?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              setError(true);
              setLoading3(false);
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        setError(true);
        setLoading3(false);
      }

    }).catch((err) => {
      // console.log("error", err);
      setError(true);
      setLoading3(false);
    });
  }

  const getTransactions = async (p) => {
    setLoading4(true);

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("token", config.app.PUBLICKEY);
    myHeaders.append("apikey", user.token);
    myHeaders.append("cpte", user.code);
    myHeaders.append("prof", user.profil);
    myHeaders.append("conn", user.espace);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      // body: urlencoded,
      redirect: 'follow'
    };

    // console.log("data send", urlencoded)

    await fetch(`${config.app.BASE_URL}/${config.app.PROJECT}/transactions?limit=1000000000&page=${p + 1}&deb=${currentdate}`, requestOptions).then((response) => {
      if (response?.status === 200) {
        response.json().then(async (data) => {
          // console.log("resonse jsondecode", data?.body?.data);
          if (data?.head) {
            let clientarray = [];

            clientarray = data?.body?.data;

            settransactions(clientarray);
            setLoading4(false);
          } else {
            if (data?.body?.data?.msg === "expiredsession") {
              logoutUser();
              navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
              setError(true);
              setLoading4(false);
            }
          }
        });
      } else if (response?.status === 401) {
        logoutUser();
        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
      } else {
        setError(true);
        setLoading4(false);
      }

    }).catch((err) => {
      // console.log("error", err);
      setError(true);
      setLoading4(false);
    });
  }



  // comportements
  useEffect(() => {
    // getElementsList(page);
    getCounts(page);
    getRetraits(page);
    getSites(page);
    getHotspots(page);
    getTransactions(page);
  }, []);


  // affichage
  return (
    <div className="col-md-12 mb-3">
      <div className="card">
        <div className="card-body">
          <div className="row mb-3">
            <div className="col-md-3 mb-4">
              <div className="card border-left-info shadow h-100 py-2">
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                        Transactions d'aujourd'hui </div>
                      <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbtjour} T / {monttjour} XAF</div>
                    </div>
                    <div className="col-auto">
                      <CreditCard className="text-info" style={{ fontSize: 48 }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card border-left-info shadow h-100 py-2">
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                        Transactions du mois </div>
                      <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbtmois} T / {monttmois} XAF</div>
                    </div>
                    <div className="col-auto">
                      <CreditCard className="text-info" style={{ fontSize: 48 }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card border-left-info shadow h-100 py-2">
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                        Transactions de l'année </div>
                      <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbtannee} T / {monttannee} XAF</div>
                    </div>
                    <div className="col-auto">
                      <CreditCard className="text-info" style={{ fontSize: 48 }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card border-left-info shadow h-100 py-2">
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-info text-uppercase mb-1">
                        Transactions total </div>
                      <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbttotal} T / {montttotal} XAF</div>
                    </div>
                    <div className="col-auto">
                      <CreditCard className="text-info" style={{ fontSize: 48 }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-5">
            <div className="col-md-3 mb-4">
              <div className="card border-left-dark shadow h-100 py-2">
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                        Nombre de Revendeurs </div>
                      <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbrevendeur} revendeurs</div>
                    </div>
                    <div className="col-auto">
                      <People className="text-dark" style={{ fontSize: 48 }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card border-left-dark shadow h-100 py-2">
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                        Nombre de site </div>
                      <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbsite} sites</div>
                    </div>
                    <div className="col-auto">
                      <BuildingFill className="text-dark" style={{ fontSize: 48 }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card border-left-dark shadow h-100 py-2">
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                        Utilisateurs connectés au réseau </div>
                      <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbuser} utilisateurs</div>
                    </div>
                    <div className="col-auto">
                      <PeopleFill className="text-dark" style={{ fontSize: 48 }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card border-left-dark shadow h-100 py-2">
                <div className="card-body">
                  <div className="row no-gutters align-items-center">
                    <div className="col mr-2">
                      <div className="text-xs font-weight-bold text-dark text-uppercase mb-1">
                        Utilisateurs connectés à internet </div>
                      <div className="h5 mb-0 font-weight-bold text-gray-800 mt-3">{nbuserconnect} utilisateurs</div>
                    </div>
                    <div className="col-auto">
                      <PersonCheckFill className="text-dark" style={{ fontSize: 48 }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 mb-3">
              <div className="row">
                <div className="col-md-12">
                  <Link className="text-success float-right" to={"/demandes-retrait"}>Voir +</Link>
                  <h6 className="text-dark">Liste des demandes de retrait en attente de traitement</h6>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <table className="mb-0 table table-bordered">
                    <thead className="bg-primary">
                      <tr className="bg-primary text-white">
                        <th className="text-center">#</th>
                        {(user?.isFullAction || user?.isAdminAction) && <th>Revendeur</th>}
                        <th>Numéro téléphone</th>
                        <th>Noms</th>
                        <th>Montant</th>
                        <th>{textes.fr.statelabel}</th>
                        <th>{textes.fr.addeddatelabel}</th>
                        <th className="text-center">
                          {textes.fr.actionlabel}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading && retraits.length === 0 && (
                        <tr style={{ borderStyle: "none" }}>
                          <th colSpan={(user?.isFullAction || user?.isAdminAction) ? 8 : 7} className="text-center">
                            <Spinner
                              as="span"
                              animation="border"
                              size="lg"
                              role="status"
                              aria-hidden="true"
                            />
                          </th>
                        </tr>
                      )}
                      {!loading && retraits.length === 0 && (
                        <tr style={{ borderStyle: "none" }}>
                          <th colSpan={(user?.isFullAction || user?.isAdminAction) ? 8 : 7} className="text-center">
                            {textes.fr.nodmretratifound}
                          </th>
                        </tr>
                      )}
                      {!loading && retraits.length > 0 &&
                        retraits?.map((item, index) => (
                          <Allretrait
                            retrait={item}
                            position={config.app.limit * page + index}
                            key={index}
                          />
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="row">
                <div className="col-md-12">
                  <Link className="text-success float-right" to={"/sites"}>Voir +</Link>
                  <h6 className="text-dark">Liste des site à traiter</h6>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="table-responsive mb-3">
                    <table className="mb-0 table table-bordered">
                      <thead className="bg-primary">
                        <tr className="bg-primary text-white">
                          <th className="text-center">#</th>
                          <th>Revendeur</th>
                          <th>Nom</th>
                          {/* <th>IP Public</th>
                          <th>IP Local</th> */}
                          {/* <th>{textes.fr.statelabel}</th>
                          <th>{textes.fr.addeddatelabel}</th> */}
                          <th>{textes.fr.statelabel}</th>
                          <th className="text-center">
                            {textes.fr.actionlabel}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading2 && sites.length === 0 && (
                          <tr style={{ borderStyle: "none" }}>
                            <th colSpan={5} className="text-center">
                              <Spinner
                                as="span"
                                animation="border"
                                size="lg"
                                role="status"
                                aria-hidden="true"
                              />
                            </th>
                          </tr>
                        )}
                        {!loading2 && sites.length === 0 && (
                          <tr style={{ borderStyle: "none" }}>
                            <th colSpan={5} className="text-center">
                              {textes.fr.nositefound}
                            </th>
                          </tr>
                        )}
                        {!loading2 && sites.length > 0 &&
                          sites?.map((item, index) => (
                            <SiteDash
                              site={item}
                              position={config.app.limit * page + index}
                              key={index}
                            />
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="row">
                <div className="col-md-12">
                  <Link className="text-success float-right" to={"/hotspots"}>Voir +</Link>
                  <h6 className="text-dark">Liste des hotsopts à traiter</h6>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <div className="table-responsive mb-3">
                    <table className="mb-0 table table-bordered">
                      <thead className="bg-primary">
                        <tr className="bg-primary text-white">
                          <th className="text-center">#</th>
                          <th>Libelle</th>
                          <th>Site</th>
                          <th>Revendeur</th>
                          <th className="text-center">
                            {textes.fr.actionlabel}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading3 && hotsopts.length === 0 && (
                          <tr style={{ borderStyle: "none" }}>
                            <th colSpan={5} className="text-center">
                              <Spinner
                                as="span"
                                animation="border"
                                size="lg"
                                role="status"
                                aria-hidden="true"
                              />
                            </th>
                          </tr>
                        )}
                        {!loading3 && hotsopts.length === 0 && (
                          <tr style={{ borderStyle: "none" }}>
                            <th colSpan={5} className="text-center">
                              {textes.fr.nohotspotfound}
                            </th>
                          </tr>
                        )}
                        {!loading3 && hotsopts.length > 0 &&
                          hotsopts?.map((item, index) => (
                            <HotspotDash
                              hotspot={item}
                              position={config.app.limit * page + index}
                              key={index}
                            />
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 mb-3">
              <div className="row">
                <div className="col-md-12">
                  <Link className="text-success float-right" to={"/transactions"}>Voir +</Link>
                  <h6 className="text-dark">Liste des transactions du jour</h6>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 mb-3">
                  <table className="mb-0 table table-bordered">
                    <thead className="bg-primary">
                      <tr className="bg-primary text-white">
                        <th className="text-center">#</th>
                        <th>Client</th>
                        <th>Souscription</th>
                        <th>Opérateur</th>
                        <th>Montant</th>
                        <th>Montant perçu</th>
                        <th className="text-center">
                          {textes.fr.actionlabel}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading4 && transactions.length === 0 && (
                        <tr style={{ borderStyle: "none" }}>
                          <th colSpan={7} className="text-center">
                            <Spinner
                              as="span"
                              animation="border"
                              size="lg"
                              role="status"
                              aria-hidden="true"
                            />
                          </th>
                        </tr>
                      )}
                      {!loading4 && transactions.length === 0 && (
                        <tr style={{ borderStyle: "none" }}>
                          <th colSpan={7} className="text-center">
                            {textes.fr.notransactionfound}
                          </th>
                        </tr>
                      )}
                      {!loading4 && transactions.length > 0 &&
                        transactions?.map((item, index) => (
                          <TransactionDash
                            transaction={item}
                            position={(config.app.limit * page) + index}
                            key={index}
                          />
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {/* <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            headerToolbar={{
              left: "prev,next today",
              center: "title",
              right: "dayGridMonth,timeGridWeek,timeGridDay",
            }}
            initialView="dayGridMonth"
            editable={true}
            selectable={true}
            selectMirror={true}
            dayMaxEvents={false}
            weekends={true}
            events={events}
            eventClick={handleEventClick}
            eventContent={renderEventContent} // custom view
            locale={"fr-FR"}
            displayEventTime={false}
            // slotDuration="auto"
          /> */}
        </div>
      </div>
    </div>
  );
}
